import { render, staticRenderFns } from "./BA.vue?vue&type=template&id=4aee3ce3&"
import script from "./BA.vue?vue&type=script&lang=js&"
export * from "./BA.vue?vue&type=script&lang=js&"
import style0 from "../Wizard.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./NotifCustom.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports